import { TrainingStatus } from '@precheckin/models/enums/training-status.enum';
import { EClientTsaStatus } from '@precheckin/models/training/training-client-tsa-status.enum';
import { EVisitDocumentManagementStatus } from '@precheckin/models/visit/visit-document-management-status.enum';

import { ITrainingEventVisitInformation } from '../interfaces/training-event-visit-information.interface';

export class TrainingEventVisitInformation {
  trainingId: string;
  trainingStatus: TrainingStatus;
  visitId: string;
  trainingCenterId: string;
  tsaStatus?: EClientTsaStatus;
  isTsaRequired: boolean;
  documentManagementStatus?: EVisitDocumentManagementStatus;
  visitValidStartDate?: Date;
  visitValidEndDate?: Date;

  constructor(data?: ITrainingEventVisitInformation) {
    Object.assign(this, data);
  }
}
